import { useApi } from "../lib/useApi";

const ArchiveDates = ({ pool_id }) => {
  const renderArchiveDatesName = (pool_id) => {
    switch (pool_id) {
      case 6:
        return "Archive - Soccer 6";
      case 10:
        return "Archive - Soccer 10";
      case 13:
        return "Archive - Soccer 13";
      case 4:
        return "Archive - Soccer 4";
      case 16:
        return "Archive - Soccer Any 13 Xtra";
      case 11:
        return "Archive - Soccer Mega10 Jackpot";
      case 12:
        return "Archive - MegaStrike 10";
      case 1:
        return "Archive - Soccer 1";
      case 8:
        return "Archive - Soccer 8";
      case 2:
        return "Archive - Soccer 2";
      case 15:
        return "Archive - Soccer Any 15";
      case 5:
        return "Archive - Soccer Scores";
      case 7:
        return "Archive - Soccer Corners";
      default:
        return null;
    }
  };

  const { data: YearDates = [] } = useApi(`/api/GetArchiveYearMonths/${pool_id}`, {
    select: (results) => {
      const temp = [];
      for (const result of results) {
        temp.push(result);
      }
      return temp;
    },
  });

  return (
    <div className="row second">
      <div className="large-12 columns" style={{ paddingLeft: "0.3em" }}>
        <h1>{renderArchiveDatesName(pool_id)}</h1>
        {YearDates.length > 0 ? (
          YearDates.map((item, index) => (
            <div className="panel panelheader">
              <h3>{item.year}</h3>
              {YearDates[index].months.map((month_item, month_index) => (
                <a className="button button4R expand" href={"/archived-month/" + pool_id + "/" + month_item.subdate}>
                  {month_item.month}
                </a>
              ))}
            </div>
          ))
        ) : (
          <div>Loading...</div>
        )}
      </div>
    </div>
  );
};

export default ArchiveDates;
